import React from "react";
import Select from "../../../../../form/component/Select";
import {PRE_CHECKIN_IMAGE_TYPE_SELECT} from "../../../../state/detail/const";

const ROTATE_CSS_CLASS_NAMES = {
    0: 'rotate-0',
    90: 'rotate-90',
    180: 'rotate-180',
    270: 'rotate-270',
}

const IMAGE_STYLE = {
    maxHeight: '600px',
    maxWidth: '100%',
    position: 'absolute',
    width: 'auto',
    margin: 'auto',
    top: '0',
    bottom: '0',
    right: '0',
    left: '0'
};

const IMAGE_DIV_STYLE = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    textAlign: 'center',
    height: '600px'
};

const TYPE_SELECT_STYLE = {
    height: '18px'
};

const renderLastModified = (lastModified) => {
    return (
        <div className="inline-block vertical-align-top">
            <span className="badge">{lastModified}</span>
        </div>
    )
}

const renderChangePreCheckinPhotoSelect = (
    customerId,
    setImageTypeMetaData,
    fileName,
    image,
    path,
    originalImageType,
    versionId
) => {
    return (
        <div className="inline-block vertical-align-top image-slide-select">
            <Select
                object={{}}
                name="name"
                addEmpty={true}
                style={TYPE_SELECT_STYLE}
                valueList={PRE_CHECKIN_IMAGE_TYPE_SELECT}
                onChange={(name, newImageType) => {
                    if (!newImageType || newImageType === image.name) {
                        return
                    }
                    setImageTypeMetaData(
                        customerId,
                        originalImageType,
                        versionId,
                        path,
                        newImageType
                    )
                }}
            />
        </div>
    )
}

const renderRotateButtons = (
    rotateCustomerImage,
    originalImageType,
    versionId
) => {
    return (
        <div className="inline-block vertical-align-top">
            <i
                className="customer-image-rotate-icon fa fa-rotate-left"
                onClick={event => {
                    event.stopPropagation()
                    event.preventDefault()
                    rotateCustomerImage(
                        originalImageType,
                        versionId,
                        -90
                    )
                }}
            />
            &#160;
            <i
                className="customer-image-rotate-icon fa fa-rotate-right"
                onClick={event => {
                    event.stopPropagation()
                    event.preventDefault()
                    rotateCustomerImage(
                        originalImageType,
                        versionId,
                        90
                    )
                }}
            />
        </div>
    )
}

const renderImageToolbox = (
    rotateCustomerImage,
    customerId,
    setImageTypeMetaData,
    lastModified,
    fileName,
    versionId,
    originalImageType,
    original,
    rotate,
    image,
    path
) => {
    return (
        <div className="image-slider-header">
            {renderLastModified(lastModified)}
            {renderChangePreCheckinPhotoSelect(
                customerId,
                setImageTypeMetaData,
                fileName,
                image,
                path,
                originalImageType,
                versionId
            )}
            {renderRotateButtons(
                rotateCustomerImage,
                originalImageType,
                versionId
            )}
        </div>
    )
}

const renderImage = (rotate, original) => {
    return (
        <div style={IMAGE_DIV_STYLE}>
            <img style={IMAGE_STYLE} className={ROTATE_CSS_CLASS_NAMES[rotate]} src={original} alt=""/>
        </div>
    )
}

const renderImageArea = ({
                             rotateCustomerImage,
                             customerId,
                             setImageTypeMetaData,
                             lastModified,
                             fileName,
                             versionId,
                             originalImageType,
                             original,
                             rotate,
                             image,
                             path,
                         }) => {
    return (
        <div>
            {renderImageToolbox(
                rotateCustomerImage,
                customerId,
                setImageTypeMetaData,
                lastModified,
                fileName,
                versionId,
                originalImageType,
                original,
                rotate,
                image,
                path
            )}
            {renderImage(rotate, original)}
        </div>
    )
}

export default renderImageArea;



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/customerPreCheckinImageWidget/renderer/renderImageArea.js